import BookSummary from "models/BookSummary";

/**
 * Returns a BookSummary model that encapuslates the data needed to render book summary card.
 * @param {*} data Content by Query data as a JS object
 */
function getBookSummary(data) {
    let featureContent = data.FeatureContent;
    let firstSummaryIndex = 0;
    let featureContentAnnotation = featureContent && featureContent.Annotation && featureContent.Annotation.annotations;
	let bookSummary = featureContentAnnotation && featureContentAnnotation[firstSummaryIndex];

    let bookTitle = getBookTitle(data);
    let bookJacketUrl = getBookJacketUrl(data);


    if(bookSummary && bookSummary.Annotation){
        bookSummary = new BookSummary(bookSummary, bookTitle, bookJacketUrl);
    }

	return bookSummary;
}

/**
 * Retrieves the book jacket url for the current book
 * @param {*} data Content by Query data as a JS object
 */
function getBookJacketUrl(data) {
    let smallImageIndex = 0;
    let bookJacketUrl = data.TitleInfo.bookjacket_urls && data.TitleInfo.bookjacket_urls[smallImageIndex] && data.TitleInfo.bookjacket_urls[smallImageIndex].url;

    return bookJacketUrl;
}


/**
 * Retrieves the book title for the current book.
 * @param {*} data Content by Query data as a JS object
 */
function getBookTitle(data){
    let bookTitle = data.TitleInfo.main_title

    return bookTitle;
}

export { getBookSummary };



// WEBPACK FOOTER //
// ./src/data/BookSummarySelector.js